<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Empleados"
          directory="Formulario de Registro"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            Nuevo Empleado
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <employee-add-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :accreditation-area-list="accreditationAreaList"
      :positions-list="positionsList"
      :role-list="roleList"
      @close-modal="closeAddEditModal"
    />

    <dashboard-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="employee-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  name: "EmployeeIndex",
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "employee-table",
      rowData: {},
      options: {
        url: `${actions.EMPLOYEES_REGISTER}/index`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "employee-add-modal",
            modalId: "employee-add-edit-modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "employee-delete",
          },
        ],
        filters: [
          {
              "title": 'Área',
              "type": "drop-down-filter",
              "key": "area",
              "option": [],
          },
          {
              "title": 'Cargo',
              "type": "drop-down-filter",
              "key": "position",
              "option": [],
          },
          {
              "title": 'Rol',
              "type": "drop-down-filter",
              "key": "role",
              "option": [],
          },
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
        accreditationAreaList: [{ id: "", value: 'Seleccione Área' }],
        positionsList: [{ id: "", value: 'Seleccione Cargo' }],
        roleList: []
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.searchAndSelectFilterOptions();
    this.data();
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#employee-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == "Eliminar") {
        this.openDeleteModal();
      } else if (actionObj.title == 'Editar') {
        this.selectedUrl = `${actions.EMPLOYEES_REGISTER}/${rowData.id}`;
        this.openAddEditModal();
      }
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.EMPLOYEES_REGISTER}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#employee-delete").modal("hide");
          this.cancelled();
          this.searchAndSelectFilterOptions();
          if (response.status == 200) {
            this.$toastr.s('Empleado eliminado exitosamente.');
          }else{
            this.$toastr.e('Ha ocurrido un error al eliminar el Empleado');
          }
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    data() {
      this.preloader = true;
      let url = `${actions.EMPLOYEES_REGISTER}/options`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.accreditationAreaList = [
              { id: "", value: 'Seleccione Área' },
              ...response.data.area,
            ];
            this.positionsList = [
              { id: "", value: 'Seleccione Cargo' },
              ...response.data.position,
            ];
            this.roleList = [
              ...response.data.role,
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    searchAndSelectFilterOptions(){
      let url = `${actions.EMPLOYEES_REGISTER}/options`;
      this.axiosGet(url).then(response => {
        let area = this.options.filters.find(element => element.title === 'Área');
        area.option = response.data.area.map(area => {
            return {
                id:area.id,
                value:area.value
            }
        });
        let position = this.options.filters.find(element => element.title === 'Cargo');
        position.option = response.data.position.map(position => {
            return {
                id:position.id,
                value:position.value
            }
        });
        let roles = this.options.filters.find(element => element.title === 'Rol');
        roles.option = response.data.role.map(roles => {
            return {
                id:roles.id,
                value:roles.value
            }
        });
      });
    }
  },
};
</script>
